import axios from "@/api/axiosInstance";
import {
  CreateLibraryModuleRequest,
  CreateLibraryModuleResponse,
} from "./types";

export const createLibraryModule = async (
  requestData: CreateLibraryModuleRequest,
): Promise<CreateLibraryModuleResponse> => {
  const response = await axios.post<CreateLibraryModuleResponse>(
    "/api/private/learning-center/module-library",
    requestData,
  );
  return response.data;
};
